import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

/**
 * @deprecated
 */
export const NotFound = styled.p`
  text-align: center;
`;

/**
 * @deprecated
 */
export const ResultsGrid = styled.div`
  margin-top: 33px;
  display: flex;
  flex-wrap: wrap;
  width: auto;
  flex-basis: 100%;
`;

/**
 * @deprecated
 */
export const SingleResult = styled.div<{ columns: number }>`
  display: flex;
  justify-content: center;
  padding: 0 10px;
  width: 100%;
  margin-bottom: 35px;
  /* Fix wrapping on Safari 9.0 */
  flex-basis: 100%;

  & > a {
    width: 100%;
    box-shadow: 0px 0px 20px #0000000d;
  }

  ${media.md`
    max-width: 50%;
    /* Fix wrapping on Safari 9.0 */
    flex-basis: 50%;
  `}

  ${({ columns }) => media.xl`
    max-width: ${100 / columns}%;
    /* Fix wrapping on Safari 9.0 */
    flex-basis: ${100 / columns}%;
  `}
`;

/**
 * @deprecated
 */
export const ResultsWrapper = styled.div`
  margin: 0 -10px;
`;
